/**
 * fullChangePasswordDialog Component
 */
/* jshint ignore:start */
(function (itxApp) {

    'use strict';

    /**
     * Change password dialog component
     * @name fullChangePasswordDialogCtrl
     * @type ItxFullChangePasswordDialogCmpCtrl
     */
    var ItxFullChangePasswordDialogCmp = {
        bindings: {
            onUpdatePassword: '&',
            closeDialog: '&'
        },
        controller: ItxFullChangePasswordDialogCmpCtrl,
        controllerAs: 'fullChangePasswordDialogCtrl',
        templateUrl: 'full-change-password-dialog.tpl'
    };

    ItxFullChangePasswordDialogCmpCtrl.$inject = ['$scope', 'ngDialog', 'ItxLoaderFct', 'ItxErrorMessagesFct'];

    function ItxFullChangePasswordDialogCmpCtrl($scope, ngDialog, ItxLoaderFct, ItxErrorMessagesFct) {
        var _this = this;
    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxFullChangePasswordDialog', ItxFullChangePasswordDialogCmp);

    itxApp.common.ItxFullChangePasswordDialogCmp = ItxFullChangePasswordDialogCmp;
    itxApp.common.ItxFullChangePasswordDialogCmpCtrl = ItxFullChangePasswordDialogCmpCtrl;

})(window.itxApp);
/* jshint ignore:end */
